import React from 'react'

function SSOOuth2() {
  return (
    <div></div>
  )
}

export default SSOOuth2